import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-recommend-form__field" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { class: "p-recommend-form__title" }, [
  /*#__PURE__*/_createElementVNode("span", null, "語学-英語"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-label-highlight --auto-right1" }, "職")
], -1)
const _hoisted_3 = { class: "p-recommend-form__error-wrap" }
const _hoisted_4 = { class: "p-recommend-form__group-1 --type-3" }
const _hoisted_5 = { class: "p-recommend-form__group-1-block-1 --no-wrap" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "p-recommend-form__text-1" }, "TOEIC", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", null, "点", -1)
const _hoisted_8 = { class: "p-recommend-form__group-1-block-1 --no-wrap" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", { class: "p-recommend-form__text-1" }, "取得", -1)
const _hoisted_10 = { class: "--wrap-1" }
const _hoisted_11 = { class: "p-recommend-form__group-1 --type-3" }
const _hoisted_12 = { class: "p-recommend-form__group-1-block-1 --no-wrap" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", { class: "p-recommend-form__text-1" }, "TOEFL", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", null, "点", -1)
const _hoisted_15 = { class: "p-recommend-form__group-1-block-1 --no-wrap" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("p", { class: "p-recommend-form__text-1" }, "取得", -1)
const _hoisted_17 = { class: "--wrap-1" }
const _hoisted_18 = { class: "p-recommend-form__group-1 --type-3" }
const _hoisted_19 = { class: "p-recommend-form__group-1-block-1 --no-wrap" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("p", { class: "p-recommend-form__text-1" }, "英語レベル", -1)
const _hoisted_21 = { class: "-is-select-wrap" }

import InvalidMessage from '@/components/InvalidMessage.vue';
import ValidatableField from '@/components/ValidatableField.vue';
import YearMonthSelect from '../../components/YearMonthSelect.vue';
import ResumeSelect from '../../components/ResumeSelect.vue';
import { useFieldValue } from 'vee-validate';
import { ref, watch } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'QualEnglish',
  setup(__props) {

const minYearSelect = ref<number>(0);
const maxYearSelect = ref<number>(0);
const birthDateYValue = useFieldValue('birthDateY');
watch(birthDateYValue, (newVal: any) => {
  if (newVal) {
    minYearSelect.value = newVal + 13;
    maxYearSelect.value = newVal + 100;
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(InvalidMessage, { name: "qualLangDetail.toeic" }),
      _createVNode(InvalidMessage, { name: "qualLangDetail.toeicY" }),
      _createVNode(InvalidMessage, { name: "qualLangDetail.toeicM" }),
      _createVNode(InvalidMessage, { name: "qualLangDetail.toefl" }),
      _createVNode(InvalidMessage, { name: "qualLangDetail.toeflY" }),
      _createVNode(InvalidMessage, { name: "qualLangDetail.toeflM" })
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createVNode(ValidatableField, {
          name: "qualLangDetail.toeic",
          rules: "numeric|max:3",
          maxlength: "3",
          label: "TOEIC",
          class: "p-recommend-form__input-1",
          id: "form-toeic",
          placeholder: "0"
        }),
        _hoisted_7
      ]),
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        _createElementVNode("div", _hoisted_10, [
          _createVNode(YearMonthSelect, {
            name: {year: 'qualLangDetail.toeicY', month: 'qualLangDetail.toeicM'},
            label: "TOEIC取得",
            "max-year": maxYearSelect.value,
            "min-year": minYearSelect.value
          }, null, 8, ["name", "max-year", "min-year"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        _hoisted_13,
        _createVNode(ValidatableField, {
          name: "qualLangDetail.toefl",
          rules: "numeric|max:3",
          maxlength: "3",
          class: "p-recommend-form__input-1",
          id: "form-toefl",
          label: "TOEFL",
          placeholder: "0"
        }),
        _hoisted_14
      ]),
      _createElementVNode("div", _hoisted_15, [
        _hoisted_16,
        _createElementVNode("div", _hoisted_17, [
          _createVNode(YearMonthSelect, {
            name: {year: 'qualLangDetail.toeflY', month: 'qualLangDetail.toeflM'},
            label: "TOEFL取得",
            "max-year": maxYearSelect.value,
            "min-year": minYearSelect.value
          }, null, 8, ["name", "max-year", "min-year"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_18, [
      _createElementVNode("div", _hoisted_19, [
        _hoisted_20,
        _createElementVNode("div", _hoisted_21, [
          _createVNode(ResumeSelect, {
            "class-name": "p-recommend-form__select",
            name: "qualLangDetail.englishLevelId",
            label: "英語レベル",
            id: "languageLevel"
          })
        ])
      ])
    ])
  ]))
}
}

})